import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { PersonalTrainerRequestForm } from '../../../components/index/service-category/personal-trainer/PersonalTrainerRequestForm'
import { getRequestJSON } from '../../../api/index/location-api'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../../service/wp-blogs-store'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;

  return (
    <>
      <Head>
        <title>{`Cheapest Gym Memberships In Singapore For ${year}`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={`A rundown of the cheapest gym memberships in Singapore for ${year} to help achieve your fitness goals without hurting your wallet.`}/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/personal-trainer/cheap-gym-membership-singapore" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Cheapest Gym Memberships In Singapore For ${year}`}/>
        <meta property="og:description" content={`A rundown of the cheapest gym memberships in Singapore for ${year} to help achieve your fitness goals without hurting your wallet.`} />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-21T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/gym.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/gym.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/personal-trainer/cheap-gym-membership-singapore"/>
        <meta name="twitter:title" content={`Cheapest Gym Memberships In Singapore For ${year}`}/> 
        <meta name="twitter:description" content={`A rundown of the cheapest gym memberships in Singapore for ${year} to help achieve your fitness goals without hurting your wallet.`}/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/cheap-gym-membership-singapore" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/cheap-gym-membership-singapore"},"headline":"Cheapest Gym Memberships In Singapore For ${year}","description":"A rundown of the cheapest gym memberships in Singapore for ${year} to help achieve your fitness goals without hurting your wallet.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/gym.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-21T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"personal-trainer","item":"https://www.stringssg.com/sg/personal-trainer"},{"@type":"ListItem","position":1,"name":"cheap-gym-membership"}]}]}`
          }}
        />
        </Head>
        <div>
            <PersonalTrainerRequestForm requestCategorySettings={requestCategorySettings}/>
            <div className='max-w-5xl mx-auto py-5 px-2'>

                <div className='space-y-2'>
                    <h1 className='text-xl text-gray-500 font-semibold'>Cheapest Gym Memberships in Singapore for {year}</h1>
                    <div className='text-gray-400 text-xs'>
                        <time dateTime={modifiedDate}>Updated - {new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                    </div>
                </div>
                <div className='pt-2 pb-10 text-gray-500 leading-8 space-y-10'>
                    <div className='py-2 space-y-2'>
                        <p className=''>
                            With the rising number of gyms in Singapore, it might be a daunting task to find a gym that is budget friendly.
                        </p>
                        <h3 className='font-bold pt-2'>What is the cost of Gym membership in Singapore?</h3>
                        <p className=''>
                            With Singapore being one of the most expensive city to live in, the average monthly charges of a gym membership are around $170. We bring to you a rundown of the cheapest gym memberships in Singapore for {year} to help achieve your fitness goals without hurting your wallet.
                        </p>
                    </div>
                    <div className='space-y-5'>
                        <div className='space-y-2'>
                            <h3 className='text-lg font-bold'>
                                1. ActiveSG Gyms
                            </h3>
                            <div className='relative h-96 max-w-xl'>
                                <Image className='rounded-lg'
                                    src={s3Static + "blog/health+and+fitness/gyms/activeSG.jpg"}
                                    fill
                                    style={{objectFit: 'cover'}}
                                    placeholder='blur'
                                    blurDataURL={s3Static + "placeholder.png"}
                                    alt='ActiveSG Gym StringsSG'
                                />  
                            </div>                    
                            <i className='text-sm'>Image credit - ActiveSG</i>        
                            <p>
                                ActiveSG is a Singapore nationwide movement to Sport Singapore to offer its residents with various sports experience for a healthy living. 
                                ActiveSG provides sport center facilities in multiple locations in Singapore with several gym facilities for the community.
                                If you know how ot take care of yourself in the gym and do not wish to spend a bulk in a fancy gym membership then ActiveSG gyms may be the go-to place
                                for you.
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>ActiveSG Gym Location</h3>
                            <p>
                                Here is a complete list of ActiveSG gyms in Singapore that you can access - 
                                <Link href="https://www.myactivesg.com/Facilities/Gyms" className='text-orange-600' rel='noopener noreferrer nofollow' 
                                target="_blank"> https://www.myactivesg.com/Facilities/Gyms</Link>
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>
                                ActiveSG Gym Per Entry Rates (Walkin fees)
                            </h3>
                            <p>ActiveSG Gym standard rate is $3.30. For Singaporean and PR it is $2.50 and for Students/Senior citizens it is $1.50.</p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>
                                ActiveSG Gym Membership fees
                            </h3>
                            <p>ActiveSG Gym offers one of the most affordable Gym membership packages in Singapore. The duration of the membership can range from 1 month to 12 months and the 
                                price can range between $9 Student membership for one month to $300 Adult membership for 12 months. Below is a complete breakdown of the membership fees.
                            </p>
                            <div className='space-y-2'>
                                <u>Peak - <span className='text-sm'>Access to all ActiveGYM™ facilities island wide, every day, all opening hours</span></u>
                                <table className='border-collapse border border-slate-400 text-center text-sm w-full'>
                                    <thead>
                                        <tr>
                                            <th className='p-1 font-normal text-orange-600'>
                                                Duration<br/>(in months)
                                            </th>
                                            <th className='p-1 font-normal text-orange-600'>
                                                Adult<br/>(18-54 yrs)      
                                            </th>
                                            <th className='p-1 font-normal text-orange-600'>
                                                Students/<br/>Senior Citizen
                                            </th>                                
                                        </tr>
                                    </thead>
                                    <tbody className='space-x-5'>
                                        <tr className='table-row text-gray-500 border border-slate-300'>
                                            <td className='p-1'>1</td>
                                            <td className='p-1'>$30</td>
                                            <td className='p-1'>$18</td>
                                        </tr>
                                        <tr className='table-row text-gray-500 border border-slate-300'>
                                            <td className='p-1'>6</td>
                                            <td className='p-1'>$160</td>
                                            <td className='p-1'>$95</td>
                                        </tr>
                                        <tr className='table-row text-gray-500 border border-slate-300'>
                                            <td className='p-1'>12</td>
                                            <td className='p-1'>$300</td>
                                            <td className='p-1'>$180</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='space-y-2'>
                                <u>Off Peak - <span className='text-sm'>Access to all ActiveGYM™ facilities island wide, Monday - Friday from opening till 4pm (except public holiday)</span></u>
                                <table className='border-collapse border border-slate-400 text-center text-sm w-full'>
                                    <thead>
                                        <tr>
                                            <th className='p-1 font-normal text-orange-600'>
                                                Duration<br/>(in months)
                                            </th>
                                            <th className='p-1 font-normal text-orange-600'>
                                                Adult<br/>(18-54 yrs)      
                                            </th>
                                            <th className='p-1 font-normal text-orange-600'>
                                                Students/<br/>Senior Citizen
                                            </th>                                
                                        </tr>
                                    </thead>
                                    <tbody className='space-x-5'>
                                        <tr className='table-row text-gray-500 border border-slate-300'>
                                            <td className='p-1'>1</td>
                                            <td className='p-1'>$15</td>
                                            <td className='p-1'>$9</td>
                                        </tr>
                                        <tr className='table-row text-gray-500 border border-slate-300'>
                                            <td className='p-1'>6</td>
                                            <td className='p-1'>$40</td>
                                            <td className='p-1'>$40</td>
                                        </tr>
                                        <tr className='table-row text-gray-500 border border-slate-300'>
                                            <td className='p-1'>12</td>
                                            <td className='p-1'>$80</td>
                                            <td className='p-1'>$80</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className='space-y-5'>
                        <div className='space-y-2'>
                            <h3 className='text-lg font-bold'>
                                2. Dennis Gym
                            </h3>
                            <div className='relative h-96 max-w-xl'>
                                <Image className='rounded-lg'
                                    src={s3Static + "blog/health+and+fitness/gyms/dennis-gym.jpg"}
                                    fill
                                    style={{objectFit: 'cover'}}
                                    placeholder='blur'
                                    blurDataURL={s3Static + "placeholder.png"}
                                    alt='Dennis Gym StringsSG'
                                />  
                            </div>
                            <i className='text-sm'>Image credit - Dennis Gym</i>        
                            <p>
                                Dennis Gym is a local born gym by Dennis Tew. He himself is quite well-built man and seems to be a fan of bodybuilding and you can see with greatest of
                                all time body builder Ronnie Coleman and Jay Cutler. Dennis Gym started small in Singapore, but has gained huge popularity among locals and now has branches
                                in multiple locations. They have a team of dedicated and committed staff willing to go the extra miles to serve the clients.
                            </p>
                            <p>
                                If you wish to get a personal training from the owner Dennis Tew, that is absolutely possible. It will cost you $3888 for 10 sessions and each session being 
                                60 minutes.
                            </p>
                        </div>
                        <div className='space-y-5'>
                            <h3 className='font-semibold'>Dennis Gym Locations</h3>
                            <div className='space-y-1'>
                                <h4>1. Farrer Park - 24 hours</h4>
                                <p className='text-sm'>159B, 161B KITCHENER ROAD Singapore 208531</p>
                            </div>
                            <div className='space-y-1'>
                                <h4>2. Taiseng - 24 hours</h4>
                            </div>
                            <div className='space-y-1'>
                                <h4>3. Jurong - 24 hours</h4>
                                <p className='text-sm'>1 Jurong West Ave 5 Singapore 649483</p>
                            </div>
                            <div className='space-y-1'>
                                <h4>4. Tampines - 24 hours</h4>
                                <p className='text-sm'>6 TAMPINES STREET 92  yo:HA Commercial @ Tampines #03-04 Singapore 528893</p>
                            </div>
                            <div className='space-y-1'>
                                <h4>5. Balestier - 24 hours</h4>
                                <p className='text-sm'>279 Balestier Road Balestier Point #B1-00 Singapore 329727</p>
                            </div>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>
                                Dennis Gym Membership Fees
                            </h3>
                            <p>
                                Dennis Gym membership can go as low as $56 per month for a 6 months membership, this is limited time special deal. Otherwise, the membership fees are still
                                very attractive with $64 per month for a 12 months membership. They also have an option for a one-month membership which will cost you $120 per month.
                            </p>
                            <table className='border-collapse border border-slate-400 text-center text-sm'>
                                <thead>
                                    <tr>
                                        <th className='py-1 px-5 font-normal text-orange-600'>
                                            Duration<br/>(in months)
                                        </th>
                                        <th className='py-1 px-5 font-normal text-orange-600'>
                                            Fees     
                                        </th>                               
                                    </tr>
                                </thead>
                                <tbody className='space-x-5'>
                                    <tr className='table-row text-gray-500 border border-slate-300'>
                                        <td className='p-1'>1</td>
                                        <td className='p-1'>$120</td>
                                    </tr>
                                    <tr className='table-row text-gray-500 border border-slate-300'>
                                        <td className='p-1'>3</td>
                                        <td className='p-1'>$230</td>
                                    </tr>
                                    <tr className='table-row text-gray-500 border border-slate-300'>
                                        <td className='p-1'>6</td>
                                        <td className='p-1'>$430</td>
                                    </tr>
                                    <tr className='table-row text-gray-500 border border-slate-300'>
                                        <td className='p-1'>12</td>
                                        <td className='p-1'>$769</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>Website - 
                            <Link href="https://www.dennisgym.net/" className='text-orange-600' rel='noopener noreferrer nofollow' target="_blank"> https://www.dennisgym.net/</Link>
                        </div>
                    </div>  
                    <div className='space-y-5'>
                        <div className='space-y-2'>
                            <h3 className='text-lg font-bold'>
                                3. Anytime Fitness
                            </h3>
                            <div className='relative h-96 max-w-xl'>
                                <Image className='rounded-lg'
                                    src={s3Static + "blog/health+and+fitness/gyms/anytime-fitness.jpg"}
                                    fill
                                    style={{objectFit: 'cover'}}
                                    placeholder='blur'
                                    blurDataURL={s3Static + "placeholder.png"}
                                    alt='Anytime Fitness StringsSG'
                                />  
                            </div>
                            <i className='text-sm'>Image credit - 24X Fitness</i>        
                            <p>
                                Anytime Fitness is a 24-hour franchise fitness club headquartered in Woodbury, Minnesota, United States. It offers one of the most affordable gym memberships
                                in Singapore with over 80 gyms in different locations of the country.
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>Anytime Fitness Locations</h3>
                            <p>
                                Here is a complete list of Anytime Fitness gyms in Singapore that you can access - 
                                <Link href="https://www.anytimefitness.sg/find-gym/" className='text-orange-600' rel='noopener noreferrer nofollow' 
                                target="_blank"> https://www.anytimefitness.sg/find-gym/</Link>
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>
                                Anytime Fitness Membership Fees
                            </h3>
                            <p>
                                Anytime Fitness offers 1-day free trial at most locations in Singapore and the membership fee may range between $80 to $120 depending on the location. 
                                You may also be eligible for free gifts lie water bottles, gym bags, show bags etc.; when you sign up for a membership, do remember to check with the sales persons.
                                There is special discounts of students and you can refer a friend for a one-month free membership.
                            </p>
                        </div>
                    </div>
                    <div className='space-y-5'>
                        <div className='space-y-2'>
                            <h3 className='text-lg font-bold'>
                                4. 24X Fitness
                            </h3>
                            <div className='relative h-96 max-w-xl'>
                                <Image className='rounded-lg'
                                    src={s3Static + "blog/health+and+fitness/gyms/24xfitness.jpeg"}
                                    fill
                                    style={{objectFit: 'cover'}}
                                    placeholder='blur'
                                    blurDataURL={s3Static + "placeholder.png"}
                                    alt='24XFitness StringsSG'
                                />  
                            </div>
                            <i className='text-sm'>Image credit - 24X Fitness</i>        
                            <p>
                                The first time we looked at this gym it reminded us of Ronnie Coleman, so if you are a Ronnie Coleman fan you will love this gym. This gym offers
                                hardcore workout equipment which encourages compound movement. They got some of the heaviest weights, a lot of bars and plates. So, if you want to be really strong
                                and muscular, then this gym is for you. Additionally, the membership fee is quite reasonable when compared to what they offer. 
                                <br/><br/>
                                If you are interested in personal training, they have got some of the best looking and well-built trainers in the city. So, walk in to one of their 
                                facilities at Bugis or Paya Lebar to explore this gym.
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>24X Fitness Location</h3>
                            <div>
                                <u>Bugis</u>
                                <p>112 Middle Rd, #02-00 Midland House, Singapore 188970</p>
                            </div>
                            <div>
                                <u>Paya Lebar</u>
                                <p>10 Eunos Rd 8, #05-10 SingPost Centre, Singapore 408600</p>
                            </div>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>
                                24X Fitness Membership Fees
                            </h3>
                            <p>
                                24X Fitness provides a 12 months membership at $95.23 per month and a 18 months membership at $84.53 per month.
                            </p>
                        </div>
                    </div>
                    <div className='space-y-5'>
                        <div className='space-y-2'>
                            <h3 className='text-lg font-bold'>
                                5. Gym Pod
                            </h3>
                            <div className='relative h-96 max-w-xl'>
                                <Image className='rounded-lg'
                                    src={s3Static + "blog/health+and+fitness/gyms/gym-pod.jpg"}
                                    fill
                                    style={{objectFit: 'cover'}}
                                    placeholder='blur'
                                    blurDataURL={s3Static + "placeholder.png"}
                                    alt='Gym Pod StringsSG'
                                />  
                            </div>
                            <i className='text-sm'>Image credit - Gym Pod</i>        
                            <p>
                                If you like your work out sessions to be private then Gym pod is for you. They provide you with a fully private gym that you can book with your smartphone.
                                They are literally gyms in a pod like structure located in over 30 different areas in Singapore and growing.
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>Gym Pod Location</h3>
                            <p>
                                Here is a complete list of Gym Pods in Singapore that you can access - 
                                <Link href="https://www.thegympod.com/locations/" className='text-orange-600' rel='noopener noreferrer nofollow' 
                                target="_blank"> https://www.thegympod.com/locations/</Link>
                            </p>
                        </div>
                        <div className='space-y-1'>
                            <h3 className='font-semibold'>
                                Gym Pod Fees
                            </h3>
                            <p>
                                Gym Pod offers both pay-per-use at $7.50 onwards per person and monthly subscription plans for convenience and efficiency.
                            </p>
                            <p>
                                Here is the link to the pricing details - 
                                <Link href="https://www.thegympod.com/pricing/" className='text-orange-600' rel='noopener noreferrer nofollow' 
                                target="_blank"> https://www.thegympod.com/pricing/</Link>
                            </p>
                        </div>
                    </div>
                </div>
                <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
            </div>
      </div>
      <div className='fixed bottom-0 w-full text-center text-lg'>
          <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                  Personal trainer Singapore - no gym membership needed
          </Link>
      </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}